import './notFound.css'

const NotFound = () => (
  <div className="not-found">
    <h1>Not Found</h1>
  </div>
)

export default NotFound